import { createFileRoute } from '@tanstack/react-router'
import { shiftQueryOptions } from '../../../../features/pos/queries'
import { ShiftDetailPage } from '../../../../features/pos/shift-detail-page'

export const Route = createFileRoute('/_app/pos/shifts/$shiftId')({
  staticData: { crumb: 'posShift' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(shiftQueryOptions(params.shiftId)),
  component: ShiftDetailPage,
})
